import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { withRouter } from 'react-router-dom';
import withData from '@bd/bdcore-data';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import PageHelmet from '@bd/bdcore-pagehelmet';


import Header from '../../components/Header';
import Footer from '../../components/Footer';
import InsideHeader from '../../components/InsideHeader';
import PageIntroBannerAlt from '../../components/PageIntroBannerAlt';
import TestimonialBanner from '../../components/TestimonialBanner';
import CtaBanner from '../../components/CtaBanner';
import ContactMenu from './ContactMenu';
import ContactForm from './ContactForm';

function ContactUs({ page, match }) {
  if (!page) {
    return null;
  }

  return (
    <div className="contact-us">
      <InsideHeader h1="Contact Us" background={get(page, 'page_image.contentUrl')} />
      <PageHelmet page={page} />
      <Header />
      <ContactMenu />
      <div className="container">
        <div className="row">
          <div className="col-12">
            <PageIntroBannerAlt
              h2={get(page, 'intro_banner[0].main_headline')}
              p={get(page, 'intro_banner[0].paragraph')}
              background={get(page, 'intro_banner[0].photo.contentUrl')}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 mx-auto">
            <div className="container">
              <div className="row">
                <div className="col-lg-3 contact-form-wrapper">
                  <p dangerouslySetInnerHTML={SanitizeHtml(page.contact_details[0].text_body)} />
                  <h4>Corporate Office</h4>
                  <p dangerouslySetInnerHTML={SanitizeHtml(page.contact_details[0].office)} />
                  <h4>Sales</h4>
                  <p dangerouslySetInnerHTML={SanitizeHtml(page.contact_details[0].sales)} />
                </div>
                <div className="col-lg-8 ml-auto">
                  <ContactForm match={match} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CtaBanner />
      <TestimonialBanner />
      <Footer />
    </div>
  );
}

ContactUs.propTypes = {
  page: PropTypes.object,
  match: PropTypes.object.isRequired,
};

ContactUs.defaultProps = {
  page: undefined,
};

export default withData({
  page: 'contact_us',
})(withRouter(ContactUs));



// WEBPACK FOOTER //
// ./src/pages/ContactUs/index.js